export const colors = {
  transparent: 'transparent',
  black: '#000',
  white: '#fff',
  blueAlpha: {
    50: 'rgba(19, 20, 30, 0.04)',
    100: 'rgba(19, 20, 30, 0.06)',
    200: 'rgba(19, 20, 30, 0.08)',
    300: 'rgba(19, 20, 30, 0.16)',
    400: 'rgba(19, 20, 30, 0.24)',
    500: 'rgba(19, 20, 30, 0.36)',
    600: 'rgba(19, 20, 30, 0.48)',
    700: 'rgba(19, 20, 30, 0.64)',
    800: 'rgba(19, 20, 30, 0.80)',
    900: 'rgba(19, 20, 30, .92)',
  },
  blue: {
    100: '#F0FBFE',
    200: '#E7F4FC',
    300: '#ABD8F2',
    400: '#3CCEF6',
    500: '#01BFF3',
    600: '#037DBA',
    700: '#256B8A',
    800: '#0E3F53',
    900: '#13141E',
  },
  gray: {
    50: '#F5F6FA',
    100: '#E5E5E5',
    200: '#CCCDCF',
    300: '#B3B4BA',
    400: '#9B9CA4',
    500: '#82838E',
    600: '#696B79',
    700: '#505263',
    800: '#393E52',
    900: '#2F3243',
  },
  red: {
    500: '#FF5252',
  },
};

export default colors;
